import { useTranslatedOptionEnum } from '@if/mui'
import { Select } from '@mui/material'
import { EPeriod, getEPeriodList } from '@src/types/Dto/Home'

interface PeriodSelectProps {
  selectedPeriod: EPeriod
  onPeriodChange: (period: EPeriod) => void
}

const PeriodSelect = ({ selectedPeriod, onPeriodChange }: PeriodSelectProps) => {
  const options = useTranslatedOptionEnum('enum.period', getEPeriodList())

  return (
    <Select
      sx={{ width: 300 }}
      value={selectedPeriod}
      onChange={(event) => onPeriodChange(event.target.value as EPeriod)}
    >
      {options}
    </Select>
  )
}

export default PeriodSelect
